<template>
  <div>
    <h3>Contatos</h3>
    <Contatos v-model="user.pessoa_fisica.contatos" />
  </div>
</template>

<script>
import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty.js";
import Contatos from "@/components/Form/Contatos";
import { mapState } from "vuex";

export default {
  components: { Contatos },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    isValid() {
      // this.$v.user.$touch();
      // return !this.$v.user.$anyError;
      return true;
    },
  },
  created() {
    if (!this.user.pessoa_fisica) {
      this.user.pessoa_fisica = {};
    }

    if (!this.user.pessoa_fisica.contatos) {
      this.user.pessoa_fisica.contatos = contatos_empty();
      this.user.pessoa_fisica.contatos.emails = [{ value: this.user.email }];
    }
  },
};
</script>

<style></style>
